import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import style from './People.module.css';
import FriendCard from '../../components/FriendCard/FriendCard';
import { Link } from 'react-router-dom';
import spinner from '../../assets/Spinner.svg'
import FormInput from '../../components/FormInput/FormInput';
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton';
import { toast } from 'react-toastify';

import { useAuthUser } from '../../hooks/useAuthUser';

// Removed server-only Clerk import to avoid bundling Next.js in CRA



const API_URL = process.env.REACT_APP_API_URL;

const People = () => {
	const { user } = useAuthUser()
	const DEFAULT_USER_ID = "user_2PSVExD2Jze2iGYg75qSShJe8If";


	const [people, setPeople] = useState(null);
	const [searchInput, setSearchInput] = useState('')


	const getPeople = useCallback(() => {
		const userId = user?.id || DEFAULT_USER_ID; // Use default user ID if user or user.id is not available

		axios.get(`${API_URL}/recommendations/people/${userId}`)
			.then(res => setPeople(res.data))
			.catch(err => console.log('error', err.message));

		console.log('get people');
	}, [user])

	const handleSearchTtextChange = event => {
		setSearchInput(event.target.value);
	}

	const getSearchResults = () => {
		if (searchInput === '') {
			toast('Search field is empty')
			return
		}

		setPeople(null)
		axios.get(`${API_URL}/search/people/${searchInput}`)
			.then(res => setPeople(res.data))
			.catch(err => console.log('error', err.message));
		console.log('got results for' + searchInput)
	}

	useEffect(() => {
		getPeople()
	}, [getPeople])


	// Removed server-side clerkClient usage in client code

	return (
		<div className={style.PeoplePage}>
			<div className='SearchContainer'>
				<FormInput
					placeholder='Search for usernames'
					change={handleSearchTtextChange}
					width={window.innerWidth < 500 ? '240px' : '480px'}
					onEnter={() => getSearchResults()}
				/>

				<PrimaryButton
					text='Search'
					click={() => getSearchResults()}
					width='120px'
				/>
			</div>

			{people ? (
				people.length > 0 ? ( // Check if people array has items
					<div className={style.CardsContainer}>
						{people.map(person => (
							<Link key={person.userID} to={`/profile/${person.userID}`}>
								<FriendCard
									key={person._id}
									username={person.username}
									profileImage={person.profileImageLink}
									userPlan={person.userPlan}
									totalXP={person.totalXP}
								/>
							</Link>
						))}
					</div>
				) : (
					<p className={style.EmptyMessage}>No people found</p>
				)
			) : (
				<img src={spinner} alt="" className={style.LoadingSpinner} />
			)}
		</div>
	);

}

export default People;